/**
 *
 * Asynchronously loads the component for Tickets
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./app/containers/Tickets/Loadable.js